const DESCENDING_TYPES = new Set(['number', 'date', 'datetime']);
const NUMBER_PATTERN = /(^|\s)(amount|count|total|times|age|days?|sessions?|members?|attendance|contributions?|baptisms?|students?|groups?|number)(\s|$)/;
const DATE_PATTERN = /(^|\s)(date|time|created|updated|submitted|visit|attended|taught|birthday|completed)(\s|$)/;

const normalizeColumnName = (column) => `${column.accessor || ''} ${column.value || ''}`
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/[_-]/g, ' ')
    .toLowerCase();

export const getSortType = (column) => {
    if (column.sortType) return column.sortType;
    const name = normalizeColumnName(column);
    if (NUMBER_PATTERN.test(name)) return 'number';
    if (DATE_PATTERN.test(name)) return 'date';
    return 'text';
};

export const getDefaultSortDirection = (column) => {
    if (column.defaultSortDirection) return column.defaultSortDirection;
    return DESCENDING_TYPES.has(getSortType(column)) ? 'desc' : 'asc';
};
